<script setup>
import { inject } from "vue";

const bulk_upload_response = inject("bulk_upload_response");
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">NOT PRIMARY COURSE(S)</h3>
            </div>
            <div class="card-body" x-data="filter-options">
              <div class="row">
                <label
                  v-if="bulk_upload_response.notPrimaryData?.length !== 0"
                  style="color: red"
                >
                  {{ bulk_upload_response.notPrimaryData?.length }}
                  device{{
                    bulk_upload_response.notPrimaryData?.length === 1 ? "" : "s"
                  }}
                  tried to be uploaded on the course which is not primary.
                </label>
                <table
                  v-if="bulk_upload_response.notPrimaryData?.length !== 0"
                  class="table table-striped"
                >
                  <thead>
                    <tr>
                      <th>ROW NO.</th>
                      <th>IMEI</th>
                      <th>ICCID</th>
                      <th>MSISDN</th>
                      <th>Device Class</th>
                      <th>Device Type</th>
                      <th>Course</th>
                      <th>Provider</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="primary in bulk_upload_response.notPrimaryData"
                      :key="primary.row"
                    >
                      <td>{{ primary.row }}</td>
                      <td>{{ primary.imei }}</td>
                      <td>{{ primary.iccid }}</td>
                      <td>{{ primary.msisdn }}</td>
                      <td>{{ primary.device_class }}</td>
                      <td>{{ primary.device_type }}</td>
                      <td style="color: red">{{ primary.server_name }}</td>
                      <td>{{ primary.provider }}</td>
                    </tr>
                  </tbody>
                </table>

                <div v-else style="color: green; font-weight: bold">
                  All Course(s) are primary ones.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style></style>
